import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const discountApi = createApi({
   reducerPath: 'discountApi',
   baseQuery: baseQueryWithReauth,
   tagTypes: ['Discount'],
   endpoints: (builder) => ({
      getDiscounts: builder.query({
         query: ({ limit = 10, page = 1, search = '' }) => ({
            url: `discount/list?limit=${limit}&page=${page}&search=${search}`,
            method: 'GET',
         }),
         providesTags: [{ type: 'Discount', id: 'LIST' }],
      }),

      getDiscountById: builder.query({
         query: (id) => ({
            url: `discount/view/${id}`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'Discount', id }],
      }),

      createDiscount: builder.mutation({
         query: (req) => ({
            url: 'discount/create',
            method: 'POST',
            body: req,
         }),
         invalidatesTags: [{ type: 'Discount', id: 'LIST' }],
      }),

      updateDiscount: builder.mutation({
         query: ({ id, ...req }) => ({
            url: `discount/update/${id}`,
            method: 'PUT',
            body: req,
         }),
         invalidatesTags: (result, error, { id }) => [
            { type: 'Discount', id: 'LIST' },
            { type: 'Discount', id },
         ],
      }),

      deleteDiscount: builder.mutation({
         query: (id) => ({
            url: `discount/delete/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: [{ type: 'Discount', id: 'LIST' }],
      }),
   }),
});

export const {
   useGetDiscountsQuery,
   useGetDiscountByIdQuery,
   useCreateDiscountMutation,
   useUpdateDiscountMutation,
   useDeleteDiscountMutation,
} = discountApi;
